<!-- =========================================================================================
    File Name: Login.vue
    Description: Login Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuesax Admin - VueJS Dashboard Admin Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div
    class="flex items-center justify-center w-full h-screen bg-img vx-row no-gutter"
    id="page-login"
  >
    <div class="m-4 vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0">
      <vx-card>
        <div slot="no-body" class="full-page-bg-color">
          <div class="items-center justify-center vx-row no-gutter">
            <div class="hidden vx-col lg:block lg:w-1/2">
              <img
                src="@/assets/images/pages/aotga.png"
                alt="login"
                class="mx-auto lg:w-2/4"
              />
            </div>
            <div class="vx-col sm:w-full md:w-full lg:w-1/2 d-theme-dark-bg">
              <div class="p-20">
                <div class="mb-8 vx-card__title">
                  <h1 class="mb-4">AOTGA MTMS</h1>
                  <p>Welcome, please login to your account</p>
                </div>
                <vs-input
                  icon="icon icon-user"
                  icon-pack="feather"
                  label-placeholder="Email"
                  v-model="email"
                  class="w-full no-icon-border"
                />

                <vs-input
                  type="password"
                  icon="icon icon-lock"
                  icon-pack="feather"
                  v-model="password"
                  label-placeholder="Password"
                  class="w-full mt-6 no-icon-border"
                  @keyup.enter="goLogin"
                />

                <br />
                <br />

                <vs-button class="float-right" @click="goLogin"
                  >Login</vs-button
                >
                <br />
                <br />
                <p v-if="resstate" style="color:red">{{ resmessage }}</p>
                <p v-if="errstate" style="color:red">{{ errmessage }}</p>
              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
// import bcrypt from "bcryptjs";
// import axios from "./axios_first";
import axios from "axios";
import { BASE_API_URL } from "@/constants/index.ts";

export default {
  data() {
    return {
      email: "",
      password: "",
      errstate: false,
      resstate: false,
      errmessage: null,
      resmessage: null,
      dburl: null
    };
  },
  methods: {
    async goTest() {
      await axios
        .get("/games/1")
        .then(res => {
          if (res.data.status == "error") {
            this.resstate = true;
            this.resmessage = res.data.message;
          } else {
            // console.log(res.data);
            // this.resstate = true;
            // this.resmessage = res.data.passhash;
          }
        })
        .catch(err => {
          this.errstate = true;
          this.errmessage = err;
        });
    },
    async goLogin() {
      // console.log("Login");
      // localStorage.setItem("userRole", "editor");
      // this.$router.replace("/");
      const formData = {
        email: this.email,
        password: this.password
      };

      try {
        if (this.email == "" || this.password == "") {
          this.errstate = true;
          this.errmessage = "กรุณาใส่ User หรือ Password";
        } else {
          this.errstate = false;
          this.errmessage = "";

          const response = await axios.post(
            `${BASE_API_URL}/auth-svc/auth/login`,
            formData
          );

          // console.log(response.data);
          
          if (response == "Not Found This Email") {
            this.errstate = true;
            this.errmessage = "ไม่พบผู้ใช้ในระบบ";
          } else {
            if (response.data.tokenType != "Bearer") {
              // console.log("Error")
              this.errstate = true;
              this.errmessage = response.data;
            } else {
              localStorage.setItem(
                "KK_AUTH_TOKEN",
                JSON.stringify(response.data)
              );

              // localStorage.setItem("userRole", response.data.userRole);

              // this.$router.replace("/pages/apps");
              this.$router.replace("/pages/precheck/");
            }
          }
        }
      } catch (error) {
        this.errstate = true;
        this.errmessage = error;
        this.email = "";
        this.password = "";
      }
    }
  },
  beforeCreate() {
    localStorage.removeItem("userRole");
    localStorage.removeItem("KK_AUTH_TOKEN");
  },
  created() {
    // localStorage.setItem("authurl2", window.location);
    // console.log(BASE_API_URL);
  }
};
</script>

<style lang="scss">
#page-login {
  .social-login {
    .bg-facebook {
      background-color: #1551b1;
    }
    .bg-twitter {
      background-color: #00aaff;
    }
    .bg-google {
      background-color: #4285f4;
    }
    .bg-github {
      background-color: #333;
    }
  }
}
</style>
